import React, { useState, useEffect } from "react";
import "./../../css/api-sales-tool.scss";
import { Container, Row, Col } from "react-bootstrap";

import "react-multi-carousel/lib/styles.css";
import Techstacks from "./../../component/techstacks";

import apisalestool11x from "./../../images/apisalestool/apisalestool-1-1x.png";
import apisalestool12x from "./../../images/apisalestool/apisalestool-1-2x.png";
import apisalestool21x from "./../../images/apisalestool/apisalestool-2-1x.png";
import apisalestool22x from "./../../images/apisalestool/apisalestool-2-2x.png";
import apisalestool31x from "./../../images/apisalestool/apisalestool-3-1x.png";
import apisalestool32x from "./../../images/apisalestool/apisalestool-3-2x.png";
import apisalestool41x from "./../../images/apisalestool/apisalestool-4-1x.png";
import apisalestool42x from "./../../images/apisalestool/apisalestool-4-2x.png";
import apisalestool51x from "./../../images/apisalestool/apisalestool-5-1x.png";
import apisalestool52x from "./../../images/apisalestool/apisalestool-5-2x.png";

import imgNumber1 from "./../../img/imgNumber1.svg";
import imgNumber2 from "./../../img/imgNumber2.svg";
import imgNumber3 from "./../../img/imgNumber3.svg";
import imgNumber4 from "./../../img/imgNumber4.svg";
import imgNumber5 from "./../../img/imgNumber5.svg";
import imgConclusion from "./../../img/imgConclusion.svg";

function APISalesTool(props) {

	const [apisalestool1WD, setApisalestool1WD] = useState('');
	const [apisalestool2WD, setApisalestool2WD] = useState('');
	const [apisalestool3WD, setApisalestool3WD] = useState('');
	const [apisalestool4WD, setApisalestool4WD] = useState('');
	const [apisalestool5WD, setApisalestool5WD] = useState('');
	
   useEffect(() => {
	  if( props.wd < 1200 ){
		  setApisalestool1WD(apisalestool11x);
		  setApisalestool2WD(apisalestool21x);
		  setApisalestool3WD(apisalestool31x);
		  setApisalestool4WD(apisalestool41x);
		  setApisalestool5WD(apisalestool51x);
	  } else if( props.wd >= 1200 ){
		  setApisalestool1WD(apisalestool12x);
		  setApisalestool2WD(apisalestool22x);
		  setApisalestool3WD(apisalestool32x);
		  setApisalestool4WD(apisalestool42x);
		  setApisalestool5WD(apisalestool52x);
	  }
   },[props.wd]);
  
  return (
    <div>
      <Container>
        <div className="wrapBG">
          <Row className="wrapRowAPISalesTool1">
            <Col xl="6" lg="6" md="12" sm="12">
              <h2 className="h2APISalesTool">
                <span className="h2ChatBotsTextBlue">API</span> - Інструмент Продажу
              </h2>
              <p className="pChatBotsText">
                Наша експертиза полягає в розробці рішень, що покращують процес продажу страхових продуктів за допомогою стратегічного використання API.
              </p>
              <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img
                src={apisalestool1WD}
                alt=" "
                className="imgApiSalesTool1"
              />
            </Col>
          </Row>
          <Row className="wrapRowTechStacksText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2TechStacksText">Технічні стеки</h2>
            </Col>
          </Row>
          <Row className="wrapRowTechStacksImg">
            <Col xl="12" lg="12" md="12" sm="12">
              <div id="marquee1" className="marquee">
                <div id="blockSlider" className="marquee__inner">
                  <Techstacks />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">ЗАВДАННЯ КЛІЄНТА</h2>
            </Col>
          </Row>
          <Row className="wrapRowAPISalesTool3">
            <Col xl="6" lg="6" md="12" sm="12">
              <p className="pAPISalesTool2">
                Наш клієнт мав на меті створити процес продажу страхових продуктів у співпраці з партнерами, досягаючи цього завдяки інтеграції API. Основним викликом для нашого клієнта було забезпечення стандартних API, які дозволили б партнерам безперешкодно включати весь процес продажу страхових продуктів у свої власні ІТ-системи.
                <br />
                Для клієнта було критично володіти механізмами налаштування бізнес-правил, розрахунку тарифів та сценаріїв продажу для страхових продуктів.
              </p>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img
                src={apisalestool2WD}
                alt=" "
                className="imgApiSalesTool2"
              />
            </Col>
          </Row>
          <Row className="wrapRowAPISalesTool4">
            <Col xl="6" lg="6" md="12" sm="12" className="imgApiSalesTool2Top">
              <img
                src={apisalestool3WD}
                alt=" "
                className="imgApiSalesTool3"
              />
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <p className="pAPISalesTool2">
                Це б дозволило партнерам, які підключені до API, продавати страхові продукти різної складності, з можливістю онлайн-підписання та оплати, не потребуючи впровадження складних страхових правил у своїх ІТ-системах. Зокрема, страхова компанія матиме централізований контроль та можливість змінювати бізнес-правила, тарифи та інші налаштування для страхових продуктів.
                <br />
                <br />
                Під час впровадження цього рішення клієнт надав особливу увагу отриманню інструменту для налаштування страхових продуктів, які мали продаватися через API. Основною вимогою було можливість налаштування більшості параметрів в системі, що мінімізує необхідність в обширній роботі з розробки.
              </p>
            </Col>
            <Col
              xl="6"
              lg="6"
              md="12"
              sm="12"
              className="imgApiSalesTool2Bottom"
            >
              <img
                src={apisalestool3WD}
                alt=" "
                className="imgApiSalesTool3"
              />
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">ПРОЦЕС РОЗРОБКИ</h2>
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessBlock">
            <Col xl="12" lg="12" md="12" sm="12">
              <div className="itemImgNumber itemImgNumber1">
                <img src={imgNumber1} alt="" className="imgNumber imgNumber1" />
                <p className="pDevelopmentProcess">
                  <b>Концепція рішення та визначення проблеми:</b>
                  <br/>- Співпраця з клієнтом для визначення загальної концепції рішення та визначення основних проблем, які потрібно вирішити. Цей етап ляже в основу проекту.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber2">
                <img src={imgNumber2} alt="" className="imgNumber imgNumber2" />
                <p className="pDevelopmentProcess">
                  <b>Регулярні зустрічі для виведення статусу:</b>
                  <br/>- Проведення щотижневих зустрічей для виведення статусу зі спонсором проекту та ключовими членами робочої групи. Ці зустрічі служать платформою для постійного спілкування та вирівнювання з метою проекту.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber3">
                <img src={imgNumber3} alt="" className="imgNumber imgNumber3" />
                <p className="pDevelopmentProcess">
                  <b>План дій та узгодження концепцій:</b>
                  <br/>- Розроблення планів дій та узгодження концепцій рішення та макетів. Цей ітераційний процес допомагає створити спільне бачення та розуміння напрямку рішення.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber4">
                <img src={imgNumber4} alt="" className="imgNumber imgNumber4" />
                <p className="pDevelopmentProcess">
                  <b>Демонстрація прогресу розробки:</b>
                  <br/>- Показ проміжних результатів розробки клієнту та зацікавленим сторонам проекту. Цей процес забезпечує прозорість та дозволяє отримати ранній зворотний зв'язок та внести корективи.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber5">
                <img src={imgNumber5} alt="" className="imgNumber imgNumber5" />
                <p className="pDevelopmentProcess">
                  <b>Планування масштабованості:</b>
                  <br/>- Обговорення та коригування планів масштабованості для майбутнього рішення. Масштабованість має важливе значення для врахування зростаючого попиту та змін у страховій галузі.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="wrapRowAPISalesTool5">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">РЕЗУЛЬТАТИ</h2>
            </Col>
          </Row>
          <Row className="wrapRowAPISalesTool6">
            <Col xl="6" lg="6" md="12" sm="12">
              <p className="pAPISalesTool2">
                Для досягнення наших цілей ми налаштували та впровадили кілька модулів системи управління відносинами з клієнтами Sagacity, зокрема:
                <br />- Sagacity API Gateway
                <br />- Sagacity Business Rules
                <br />
                <br />
                Фаза розробки тривала 3 місяці, протягом якої команда успішно врахувала всі вимоги, визначені клієнтом. У рамках розробки були створені API для продуктів, таких як ОСЦПВ, ВСЦПВ та туристичне страхування.
                <br />
                Крім того, було успішно здійснено інтеграцію з декількома партнерами, включаючи онлайн-агрегатори страхових послуг та банки.
              </p>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img
                src={apisalestool4WD}
                alt=" "
                className="imgApiSalesTool4"
              />
            </Col>
          </Row>

          <Row className="wrapRowAPISalesTool7">
            <Col xl="6" lg="6" md="12" sm="12" className="imgApiSalesTool2Top">
              <img
                src={apisalestool5WD}
                alt=" "
                className="imgApiSalesTool5"
              />
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <p className="pAPISalesTool2 pAPISalesTool2margin">
                У випадках, коли партнери могли інтегруватися лише через свої протоколи обміну даними, була проведена додаткова робота з розробки для забезпечення сумісності з API.
                <br />
                <br />
                Після запуску розробленого рішення були створені нові бізнес-процеси для продажу електронних страхових договорів, що стандартизувало підключення нових партнерів та встановило рамки підтримки.
                <br />
                <br />
                Майбутні кроки, у співпраці з клієнтом, передбачають розширення асортименту продуктів, доступних через API, щоб охопити страхування КАСКО, медичне страхування та страхування нерухомого майна. Це підкреслює зобов'язання до постійної інновації та розвитку продукту.
              </p>
            </Col>
            <Col
              xl="6"
              lg="6"
              md="12"
              sm="12"
              className="imgApiSalesTool2Bottom"
            >
              <img
                src={apisalestool5WD}
                alt=" "
                className="imgApiSalesTool5"
              />
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">ВИСНОВОК</h2>
            </Col>
          </Row>
          <Row className="wrapRowConclusion">
            <Col xl="6" lg="6" md="12" sm="12">
              <div className="wrapConclusionText">
                <p className="pConclusion">
                  Цей результат є переконливим прикладом того, як навіть під час таких викликів як карантин, запуск нових рішень може ефективно допомагати страховим компаніям залучати нових клієнтів. Особливо варто відзначити, що це рішення має додаткову перевагу у тому, що воно дозволяє людям без попереднього досвіду в страхуванні генерувати додатковий дохід.
                  <br/>Це підкреслює цінність інновацій та адаптивності для трансформації взаємодії з клієнтами та бізнес-операцій.
                </p>
                <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
              </div>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img src={imgConclusion} alt="" className="imgConclusion" />
            </Col>
          </Row>
        </div>
      </Container>
    </div>

);
}

export default APISalesTool;
